// extracted by mini-css-extract-plugin
module.exports = {"fingerBlock":"style_fingerBlock__17_0p","back":"style_back__1PQ-g","svg":"style_svg__1rXXw","greenColor":"style_greenColor__1yQAg","redColor":"style_redColor__3_Oef"};